export default __webpack_public_path__ + "static/media/blogr.68f4bc4b.svg";